import { render, staticRenderFns } from "./GraficoBarras.vue?vue&type=template&id=5b0bed48&"
import script from "./GraficoBarras.vue?vue&type=script&lang=js&"
export * from "./GraficoBarras.vue?vue&type=script&lang=js&"
import style0 from "./GraficoBarras.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VDivider,VRow})
